import { Price } from 'app/types/authorization'
import Currency from 'app/types/currency'

function priceInCents(price: Price | null | undefined): number {
  if (!price) {
    return 0
  }
  return price.value_in_cents ?? price.value * 100
}

function formatPrice(
  price: Price | null | undefined,
  currency: Currency | undefined
): string {
  return `${(priceInCents(price) / 100).toFixed(2)} ${currency?.toString()}`
}

function formatWithMultiplier(
  price: Price | null | undefined,
  multiplier: number,
  currency: Currency
): string {
  return `${((priceInCents(price) * multiplier) / 100).toFixed(
    2
  )} ${currency.toString()}`
}

function formatWithPercentage(
  price: Price | null | undefined,
  percentage: number,
  currency: Currency
): string {
  return `${(
    (priceInCents(price) * (percentage / (1 + percentage))) /
    100
  ).toFixed(2)} ${currency.toString()} (${(percentage * 100).toFixed(2)} %)`
}

export { priceInCents, formatPrice, formatWithMultiplier, formatWithPercentage }
